import { BUSINESS_TIME_ZONE } from './constants.js';
import { isValidTimeZone } from './place-time.js';
const dateTimeFormat = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'shortGeneric',
};
const formatterByZone = new Map();
function formatterFor(zone) {
    const cached = formatterByZone.get(zone);
    if (cached)
        return cached;
    if (!isValidTimeZone(zone)) {
        throw new RangeError(`Not an IANA time zone: ${JSON.stringify(zone)}`);
    }
    const formatter = new Intl.DateTimeFormat('en-US', { ...dateTimeFormat, timeZone: zone });
    formatterByZone.set(zone, formatter);
    return formatter;
}
/** "Oct 10, 2026, 10:00 AM CT": the instant on the wall of `zone`, with its generic label. */
export function formatPlaceDateTime(instant, zone) {
    return formatterFor(zone).format(instant);
}
/** "Oct 1, 2026, 10:00 PM PT": every instant shown to users reads in Pacific time. */
export function formatBusinessDateTime(instant) {
    return formatPlaceDateTime(instant, BUSINESS_TIME_ZONE);
}
const timeFormat = {
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'shortGeneric',
    timeZone: BUSINESS_TIME_ZONE,
};
const businessTimeFormatter = new Intl.DateTimeFormat('en-US', timeFormat);
/** "10:00 PM PT": the time of day alone, for a row that shows the day beside it. */
export function formatBusinessTime(instant) {
    return businessTimeFormatter.format(instant);
}
const zoneNameFormatterByKey = new Map();
/**
 * "CT", or "Central Time" with `long`: a zone's generic name, the same in summer and winter, by
 * the zone's rules at `at` (default now; pass the instant being labelled).
 */
export function formatTimeZoneName(zone, { long = false, at = new Date() } = {}) {
    const key = `${zone}|${long}`;
    let formatter = zoneNameFormatterByKey.get(key);
    if (!formatter) {
        if (!isValidTimeZone(zone)) {
            throw new RangeError(`Not an IANA time zone: ${JSON.stringify(zone)}`);
        }
        const timeZoneName = long ? 'longGeneric' : 'shortGeneric';
        formatter = new Intl.DateTimeFormat('en-US', { timeZone: zone, timeZoneName });
        zoneNameFormatterByKey.set(key, formatter);
    }
    const part = formatter.formatToParts(at).find(({ type }) => type === 'timeZoneName');
    return part?.value ?? zone;
}
//# sourceMappingURL=format.js.map